$ = require 'jquery'
IdCache = require 'app/scripts/db/id-cache'
ModelCache = require 'app/scripts/db/model-cache'
parseURL = require 'url-parse'
Payloads = require 'app/scripts/network/payloads'
PostRender = require 'app/scripts/views/lib/post-render'
Promise = require 'bluebird'
rpc = require 'app/scripts/network/rpc'
Time = require 'app/scripts/lib/time'
Util = require 'app/scripts/lib/util'
_ = require 'underscore'
moment = require 'moment'
xtend = require 'xtend'
f = require 'effing'
ninvoke = require 'app/scripts/lib/util/ninvoke'
assert = require 'app/scripts/lib/assert'
ApiError = require 'app/scripts/network/api-error'
{ ModelName } = require './ModelName'

extendQuery = ({ query, mappingRules }, moreQuery) ->
  query: xtend(query, moreQuery)
  mappingRules: mappingRules

preloadUncalledSentinel = {}
REPLAY_CONCURRENCY = 5

quickload = (url) ->
  preload = preloadUncalledSentinel
  Promise.fromNode (next) ->
    preload = QuickLoad.load url, next
  .catch ([statusCode, responseText]) ->
    Promise.reject ApiError.fromResponse(statusCode, responseText)
  .tap -> assert preload != preloadUncalledSentinel, "Promises resolved synchronously; didn't get preload information from QuickLoad"
  .spread (data, xhr) ->
    [data, xhr, preload]

updateServerTime = (xhr) ->
  if (serverTime = xhr.getResponseHeader('X-Server-Time'))?
    Time.updateServerTime parseInt(serverTime, 10)
  return

# Since we do the board data loads all the time, use this to prevent some of
# the loads from happening if the board looks like it is already up to date
whenBoardNotUpToDate = (fx) ->
  (id) ->
    Promise.try ->
      ModelLoader.getUpToDateBoard(id) ? fx.call(ModelLoader, id)

_waitComplete = {}
_waitCallbacks = {}

module.exports = window.ModelLoader = ModelLoader =
  _history: []
  _replaying: false
  _loadApiData: (modelType, id, payload, [path, metadataHeaderName, isHeaderLoad]...) ->
    query = payload.query
    mappingRules = payload.mappingRules ? {}
    # If we gave a class like Board, convert that to "Board"
    if !_.isString(modelType)
      modelType = modelType::typeName
    path ?= "#{ Util.pluralize(modelType) }/#{id}"

    invitationTokens = Util.invitationTokens().join(',')
    if !_.isEmpty(invitationTokens)
      # Note that this has to match the behavior of quickload; where
      # invitationTokens is added as the last thing
      query = _.extend({}, query, { invitationTokens })

    url = QuickLoad.makeUrl("/1/#{ path }", query)

    quickload(url)
    .spread (data, xhr, preload) ->
      updateServerTime(xhr)

      [data, xhr]
    .tap ->
      # We skip this logic when we're running GraphiQL because the header is never loaded in that context.
      if isHeaderLoad
        return
      else
        new Promise (resolve) -> ModelLoader.waitFor 'headerData', resolve
    .spread (data, xhr) ->
      # If we're still waiting on a render, see if we can split this data into
      # a high and low priority pieces
      if PostRender.holding && payload.splitDeferred
        { data, deferred } = payload.splitDeferred(data)

        if deferred
          PostRender.enqueue ->
            ninvoke ModelCache, 'enqueueDelta', modelType, deferred, mappingRules


      Promise.try ->
        if data
          ninvoke ModelCache, 'enqueueDelta', modelType, data, mappingRules
        else
          []
      .then (models) ->
        return models unless metadataHeaderName
        metadata = window.JSON.parse(xhr.getResponseHeader(metadataHeaderName))
        [models, metadata]

  getUpToDateBoard: (idBoardOrShortLink) ->
    if @isReplaying()
      return null

    idBoard = IdCache.getBoardId(idBoardOrShortLink)
    if !idBoard?
      return null

    board = ModelCache.get('Board', idBoard)
    if !board?
      return null

    lastUpdateChannel = rpc.getIxLastUpdate(board.id)
    if lastUpdateChannel?
      board
    else
      null

  isReplaying: ->
    @_replaying

  replay: ->
    @_replaying = true
    marker = ModelCache.mark()

    Promise.map(@_history, ({ owner, loadName, args }) =>
      @[loadName](args...)
    , { concurrency: REPLAY_CONCURRENCY })
    .then ->
      ModelCache.sweep(marker)
    .finally =>
      @_replaying = false
    .return()

  record: (owner, loadName, args...) ->
    if owner?
      @_history.push({ owner, loadName, args })
    else
      throw Error("Unclaimed #{ loadName }")

  for: (owner, loadName, args...) ->
    @record(owner, loadName, args...)
    @[loadName](args...)

  release: (owner) ->
    @_history = _.reject @_history, (entry) ->
      entry.owner == owner
    return

  loadHeaderData: ->
    @_loadApiData ModelName.MEMBER, 'me', Payloads.memberHeader, undefined, undefined, true
    .then (delta) -> ['Member', delta, Payloads.memberHeader.mappingRules]

  loadBoardsMenuData: ->
    @_loadApiData ModelName.MEMBER, 'me', Payloads.boardsMenuMinimal
    .then (delta) -> ['Member', delta, Payloads.boardsMenuMinimal.mappingRules]

  loadBoardMinimal: (id) ->
    @_loadApiData ModelName.BOARD, id, Payloads.boardMinimal

  loadBoardData: (id, payload) -> @_loadApiData ModelName.BOARD, id, payload

  loadBoardMembers: (id) ->
    @_loadApiData ModelName.MEMBER, id, {}, "boards/#{ id }/members"

  loadBoardAttachment: (idBoard) ->
    @_loadApiData  ModelName.BOARD, idBoard, Payloads.boardAttachment

  loadCanonicalCardData: (idCard) ->
    @_loadApiData ModelName.CARD, idCard, Payloads.canonicalCard, "cards/#{ idCard }"

  loadCardData: ([idBoard]..., idOrShortId) ->
    if idBoard?
      @_loadApiData ModelName.CARD, idOrShortId, Payloads.card, "boards/#{ idBoard }/cards/#{idOrShortId}"
    else
      @_loadApiData ModelName.CARD, idOrShortId, Payloads.card
  loadCardName: (idOrShortId) ->
    query =
      fields: ['name', 'shortLink'].join(',')
    @_loadApiData ModelName.CARD, idOrShortId, { query: query }
    .call 'get', 'name'
  loadCardIdBoard: (idOrShortId) ->
    query =
      fields: ['idBoard'].join(',')
    @_loadApiData ModelName.CARD, idOrShortId, { query: query }
    .call 'get', 'idBoard'
  loadCardCompleterData: (id) ->
    @_loadApiData ModelName.CARD, id, Payloads.cardCompleter
  loadCardId: (idBoard, idShort) ->
    @_loadApiData ModelName.CARD, idShort, Payloads.idCard, "boards/#{ idBoard }/cards/#{idShort}"
    .get 'id'
  loadCardDetails: (idCard, limit) ->
    @_loadApiData ModelName.CARD,
      idCard,
      extendQuery Payloads.cardDetails, { actions_limit: limit }
      "cards/#{idCard}"
  loadCardHideDetails: (idCard, limit) ->
    @_loadApiData ModelName.CARD,
      idCard,
      extendQuery Payloads.cardDetails,
        actions: 'commentCard,copyCommentCard,createCard,copyCard'
        actions_limit: limit
      "cards/#{idCard}"
  loadCardVoters: (id) ->
    @_loadApiData ModelName.CARD, id, Payloads.cardVoters, "cards/#{ id }"
  loadCardCopyData: (idBoard, idOrShortId) ->
    @_loadApiData ModelName.CARD, idOrShortId, Payloads.cardCopy, "boards/#{ idBoard }/cards/#{idOrShortId}"
  loadCardList: (idCard) ->
    @_loadApiData ModelName.LIST, idCard, Payloads.cardList, "cards/#{ idCard }/list"
  loadCardAttachment: (idCard) ->
    @_loadApiData ModelName.CARD, idCard, Payloads.cardAttachment

  loadNotification: (id) ->
    @_loadApiData ModelName.NOTIFICATION, id, query:
      fields: 'all'

  loadNotificationGroups: (idCards) ->
    @_loadApiData ModelName.NOTIFICATION_GROUP, null, { query: { idCards } }, 'notificationGroups'

  loadMoreNotificationData: (idOrUsername, limit) ->
    notifications = ModelCache.all('Notification')
    query = {
      display: true
      filter: 'all'
      limit: limit
      page: Math.floor(notifications.length / limit)
    }
    path = "members/#{ idOrUsername }/notifications"

    @_loadApiData ModelName.NOTIFICATION, null, { query }, path

  loadMoreUnreadNotifications: (limit) ->
    unreads = ModelCache.all('Notification').filter (notification) ->
      notification.get('unread')
    query = {
      display: true,
      limit,
      read_filter: 'unread',
      page: Math.floor(unreads.length / limit)
    }
    path = "members/me/notifications"

    @_loadApiData ModelName.NOTIFICATION, null, { query }, path

  loadAllNotificationGroupsBefore: (idNotification, limit, skip = 0) ->
    @loadMoreNotificationGroupData(limit, skip).then (models) =>
      idModels = _.chain(models)
      .map (model) ->
        model.get('notifications')
      .map (notifications) ->
        notifications.map (notification) -> notification.id
      .flatten()
      .value()

      if idModels.length > 0 && !_.contains(idModels, idNotification)
        return @loadAllNotificationGroupsBefore(idNotification, limit, skip + limit)

  loadMoreNotificationGroupData: (
    limit,
    skip = ModelCache.all('NotificationGroup').length
  ) ->
    query = {
      limit,
      skip,
      card_fields: [
        'due',
        'dueComplete',
        'idBoard',
        'idList',
        'isTemplate',
        'name',
        'subscribed',
      ],
    }
    path = "members/me/notificationGroups"

    @_loadApiData ModelName.NOTIFICATION_GROUP, null, { query }, path

  loadMemberNotificationsCount: ->
    query = { filter: 'all', grouped: true }
    path = "members/me/notificationsCount"

    @_loadApiData 'notificationsCount', null, { query }, path

  loadMinimumMemberDataForTemplatePage: (idOrUsername) ->
    @_loadApiData ModelName.MEMBER, idOrUsername, {
      query: {
        organizations: 'all',
        organization_fields: 'products',
        fields: 'oneTimeMessagesDismissed'
      }
    }

  loadMemberBoardsData: (idOrUsername) ->
    @_loadApiData ModelName.MEMBER, idOrUsername, Payloads.memberBoards

  loadMemberCardsData: (idOrUsername) ->
    @_loadApiData ModelName.MEMBER, idOrUsername, Payloads.memberCards

  loadMemberCards: (idOrUsername, modifiedSince) ->
    query =
      filter: 'visible'
      stickers: true
      attachments: true
      members: true

    if modifiedSince
      query.modifiedSince = modifiedSince

    @_loadApiData ModelName.CARD, null, { query }, "members/#{ idOrUsername }/cards"

  loadMemberEmail: (idOrUsername) ->
    @_loadApiData ModelName.MEMBER, idOrUsername, query:
      fields: 'email'
      invitationTokens: Util.invitationTokens().join(',')

  loadOrganizationMemberGhost: (idOrg, username) ->
    # If we have an invite to this organization (i.e. an invitation token
    # in our cookies) then we need to load the ghost data so we can
    # display the invitation banner
    idGhost = Util.inviteTokenFor(idOrg)?.split('-')[0]
    if !idGhost?
      return Promise.resolve({})

    query =
      fields: Payloads.memberFields
      invitationTokens: Util.invitationTokens().join(',')

    # Maybe the invitation has already been used or something; we
    # never want to prevent loading of the organization page
    @_loadApiData ModelName.MEMBER, idGhost, { query }
    .catch ApiError, -> {}

  loadMyBoardsUnreadData: ->
    @_loadApiData ModelName.MEMBER, 'me', Payloads.memberUnreadBoards

  loadMoreActionData: (modelType, idOrName, page, limit, [idModels, filter]...) ->
    query = { filter: 'all', limit, page, display: true }
    if idModels?
      query.idModels = idModels.join(',')
    if filter?
      query.filter = filter

    @_loadApiData ModelName.ACTION, idOrName, { query }, "#{modelType}s/#{ idOrName }/actions"

  loadClosedCards: (idBoard, { limit, before }) ->
    query = { stickers: true, attachments: true, pluginData: true, customFieldItems: true }
    if limit? then query.limit = limit
    if before? then query.before = before

    @_loadApiData ModelName.CARD, idBoard, { query }, "boards/#{ idBoard }/cards/closed"

  loadClosedBoards: ->
    @_loadApiData ModelName.BOARD, null, { query: { filter: 'closed' } }, 'members/me/boards'

  loadOrgMemberLimits: ->
    @_loadApiData ModelName.MEMBER, 'me', { query: { paid_account: false, fields: 'limits' } }, 'members/me/organizations'

  loadArchivedLists: (idBoard) ->
    @_loadApiData ModelName.BOARD, idBoard, Payloads.archivedLists

  loadMemberPaidAccount: (idOrUsername) ->
    @_loadApiData ModelName.MEMBER, idOrUsername, Payloads.memberPaidAccount

  loadMemberAccountData: (idOrUsername) ->
    @_loadApiData ModelName.MEMBER, idOrUsername, Payloads.memberAccount

  loadMemberBillingData: (idOrUsername) ->
    @_loadApiData ModelName.MEMBER, idOrUsername, Payloads.memberBilling

  loadMemberLogins: (idOrUsername) ->
    @_loadApiData ModelName.MEMBER, idOrUsername, query:
      fields: 'email'
      logins: true

  loadMemberProfileData: (idOrUsername) ->
    payload = Payloads.memberProfile
    daysBack = Payloads.memberProfile_daysBack
    payload.action_since = moment().subtract(daysBack, 'days').toString()
    @_loadApiData ModelName.MEMBER, idOrUsername, Payloads.memberProfile

  loadMemberCustomBackgrounds: (idOrUsername) ->
    @_loadApiData ModelName.MEMBER, idOrUsername, query:
      fields: ''
      boardBackgrounds: 'custom'

  loadMemberCustomStickers: (idOrUsername) ->
    @_loadApiData ModelName.MEMBER, idOrUsername, query:
      fields: ''
      customStickers: 'all'

  loadMemberCustomEmoji: (idOrUsername) ->
    @_loadApiData ModelName.MEMBER, idOrUsername, query:
      fields: ''
      customEmoji: 'all'

  loadMemberEnterpriseUserType: (enterpriseIdOrName, idOrUsername) ->
    query = { fields: 'userType' }
    @_loadApiData ModelName.MEMBER, idOrUsername, { query }, "enterprises/#{enterpriseIdOrName}/members/#{idOrUsername}"

  loadMemberEnterpriseActive: (enterpriseIdOrName, idOrUsername) ->
    query = { fields: 'active' }
    @_loadApiData ModelName.MEMBER, idOrUsername, { query }, "enterprises/#{enterpriseIdOrName}/members/#{idOrUsername}"

  loadMemberNonPublicFields: (idOrUsername) ->
    query = { fields: 'nonPublic' }
    @_loadApiData ModelName.MEMBER, idOrUsername, { query }, "members/#{idOrUsername}"

  _loadOrganizationPayload: (payload, idOrOrgName) ->
    @_loadApiData ModelName.ORGANIZATION, idOrOrgName, payload

  loadOrganizationPlugins: (idOrOrgName) ->
    query = { enabledBoards: true }
    @_loadApiData ModelName.PLUGIN, null, { query }, "organizations/#{ idOrOrgName }/plugins"

  loadOrganizationData: (idOrOrgName) ->
    @_loadOrganizationPayload(Payloads.organization, idOrOrgName)

  loadOrganizationBoardsData: (idOrOrgName) ->
    @_loadOrganizationPayload(Payloads.organizationBoardsPage, idOrOrgName)

  loadOrganizationPaidAccount: (idOrOrgName) ->
    @_loadOrganizationPayload(Payloads.organizationPaidAccount, idOrOrgName)

  loadOrganizationMinimal: (idOrOrgName) ->
    @_loadOrganizationPayload(Payloads.organizationMinimal, idOrOrgName)

  loadOrganizationMembersData: (idOrOrgName) ->
    @_loadOrganizationPayload(Payloads.organizationMembers, idOrOrgName)

  loadOrganizationMembersDataWithAvailableLicenseCount: (idOrOrgName) ->
    @_loadOrganizationPayload(Payloads.organizationMembersWithAvailableLicenseCount, idOrOrgName)

  loadOrganizationMembersBoards: (idOrOrgName) ->
    @_loadOrganizationPayload(Payloads.organizationMembersBoards, idOrOrgName)

  loadOrganizationMembersCollaborators: (idOrOrgName) ->
    @_loadOrganizationPayload(Payloads.organizationMembersCollaborators, idOrOrgName)

  loadOrganizationMembersMinimal: (idOrOrgName) ->
    @_loadOrganizationPayload(Payloads.organizationMembersMinimal, idOrOrgName)

  loadOrganizationAdminsMinimal: (idOrOrgName) ->
    @_loadOrganizationPayload(Payloads.organizationAdminsMinimal, idOrOrgName)

  loadOrganizationMembersMinimalWithAvailableLicenseCount: (idOrOrgName) ->
    @_loadOrganizationPayload(Payloads.organizationFieldsMinimalWithAvailableLicenseCount, idOrOrgName)

  loadOrganizationMaximumAndAvailableLicenseCount: (idOrOrgName) ->
    @_loadOrganizationPayload(Payloads.organizationFieldsMaximumAndAvailableLicenseCount, idOrOrgName)

  loadOrganizationExportData: (idOrOrgName) ->
    @_loadOrganizationPayload(Payloads.organizationExports, idOrOrgName)

  loadOrganizationMemberMinimal: (idOrOrgName, idOrUsername) ->
    @_loadApiData ModelName.MEMBER, idOrUsername, Payloads.memberMinimal

  loadMemberOrganizationsDeactivatedMembers: ->
    @_loadApiData ModelName.ORGANIZATION, null, Payloads.memberOrganizationDeactivatedMembers, 'members/me/organizations'

  loadOrgMemberCardData: (idOrOrgName, idOrUsername) ->
    path = "organization/#{idOrOrgName}/members/#{idOrUsername}/cards"
    @_loadApiData ModelName.CARD, idOrOrgName, Payloads.orgMemberCards, path

  loadOrgNameById: (idOrganization) ->
    query =
      fields: 'name'
    @_loadApiData ModelName.ORGANIZATION, idOrganization, { query }
    .call 'get', 'name'

  loadCurrentBoardData: whenBoardNotUpToDate (id) ->
    @loadBoardData id, Payloads.currentBoardMinimal

  loadCurrentBoardWithLabelData: whenBoardNotUpToDate (id) ->
    Payloads.currentBoardMinimal.query.labels = 'all'
    Payloads.currentBoardMinimal.query.labels_limit = 1000
    delete Payloads.currentBoardSecondary.labels
    delete Payloads.currentBoardSecondary.labels_limit
    @loadBoardData id, Payloads.currentBoardMinimal

  loadBoardSecondary: whenBoardNotUpToDate (id) ->
    @_loadApiData ModelName.BOARD, id, Payloads.currentBoardSecondary

  loadBoardPluginData: whenBoardNotUpToDate (id) ->
    @_loadApiData ModelName.BOARD, id, Payloads.currentBoardPluginData

  loadBoardChecklists: (id) ->
    @_loadApiData ModelName.BOARD, id, Payloads.boardChecklists

  loadBoardCompleterData: (id) ->
    @_loadApiData ModelName.BOARD, id, Payloads.boardCompleter

  loadBoardName: (idBoard) ->
    query =
      fields: ['name', 'closed', 'shortLink'].join(',')
    @_loadApiData ModelName.BOARD, idBoard, { query }
    .call 'get', 'name'

  loadBoardPrefs: (idBoard) ->
    query =
      fields: ['prefs'].join(',')
    @_loadApiData ModelName.BOARD, idBoard, { query }
    .call 'get', 'prefs'

  loadMembersOfEnterprise: (enterpriseIdOrName, params) ->
    query = _.extend(fields: Payloads.enterpriseMemberFields, params)
    @_loadApiData ModelName.MEMBER, enterpriseIdOrName, { query },
      "enterprises/#{ enterpriseIdOrName }/members",
      "X-Trello-API-Query-Meta"

  loadEnterpriseOrganizations: (enterpriseIdOrName, params) ->
    query = _.extend(fields: Payloads.enterpriseOrganizationFields, params)
    @_loadApiData ModelName.ORGANIZATION, enterpriseIdOrName, { query },
      "enterprises/#{ enterpriseIdOrName }/organizations",
      "X-Trello-API-Query-Meta"

  loadEnterprisePendingOrganizations: (enterpriseIdOrName, query) ->
    @_loadApiData ModelName.PENDING_ORGANIZATION, enterpriseIdOrName, { query, mappingRules: Payloads.pendingOrganizations.mappingRules },
      "enterprises/#{ enterpriseIdOrName }/pendingOrganizations",
      "X-Trello-API-Query-Meta"

  loadEnterprisePublicBoards: (enterpriseIdOrName, params) ->
    query = _.extend(params,
      filter: 'public'
      organization: true
      members: 'admins'
    )

    @_loadApiData ModelName.BOARD, enterpriseIdOrName, { query },
      "enterprises/#{ enterpriseIdOrName }/boards",
      "X-Trello-API-Query-Meta"

  loadEnterprise: (enterpriseIdOrName, query) ->
    query ?=
      organizations: 'all'
      fields: [
        'displayName'
        'idAdmins'
        'idOrganizations'
        'pendingOrganizations'
        'name'
        'organizationPrefs'
        'prefs'
        'products'
        'ssoActivationFailed'
        'ssoDateDelayed'
        'pluginWhitelistingEnabled'
      ].join(',')
    @_loadApiData ModelName.ENTERPRISE, enterpriseIdOrName, { query }

  loadHighlights: ({ before, since, organization }) ->
    query = {
      board_customFields: true
      board_memberships: 'all'
      card_customFieldItems: true
      action_reactions: true
    }

    if before then query.before = before
    if since then query.since = since
    if organization then query.organization = organization

    @_loadApiData 'highlights', null, { query }, 'members/me/highlights'

  loadUpNext: ->
    query = {
      board_customFields: true
      board_memberships: 'all'
      card_customFieldItems: true
      action_reactions: true
    }

    @_loadApiData 'upNext', null, { query }, 'members/me/upNext'

  loadMyOrganizations: ->
    @loadMemberOrganizations 'me'

  loadMyOrganizationsWithoutBoards: ->
    @loadMemberOrganizations 'me', Payloads.organizationsWithoutBoards

  loadMemberOrganizationsMemberships: (idMember) ->
    @loadMemberOrganizations idMember, Payloads.organizationsMemberships

  loadMemberOrganizations: (idMember, payload = Payloads.organizations) ->
    @_loadApiData ModelName.MEMBER, idMember, payload

  loadSearchData: (query) ->
    @_loadApiData 'search', null, { query }, 'search'

  loadModel: (modelType, id, payload) ->
    @_loadApiData modelType, id, payload

  loadBoardPlugins: (id, locales) ->
    # load public plugins, which are cached based on locale
    # then load private ones separately which are not cached
    if !locales then locales = 'en'
    Promise.all([
      @_loadApiData(
        ModelName.PLUGIN
        null
        query:
          { preferredLocales: locales }
        'plugins/public'
      ),
      @_loadApiData(
        ModelName.PLUGIN
        null
        query:
          { filter: 'private' }
        "boards/#{ id }/plugins"
      )
    ]).spread (publicPlugins, privatePlugins) =>
      return publicPlugins.concat(privatePlugins)

  loadBoardEnabledPlugins: (id) ->
    @_loadApiData(
      ModelName.PLUGIN
      null
      query:
        { filter: 'enabled' }
      "boards/#{ id }/plugins"
    )

  loadEnterprisePlugins: (id) ->
    @_loadApiData(
      ModelName.PLUGIN
      null
      query:
        { filter: 'all' }
      "enterprises/#{ id }/plugins"
    )

  loadPluginsWithClaimedDomains: (id) ->
    @_loadApiData(
      ModelName.PLUGIN
      null
      query:
        { filter: 'hasClaimedDomains' }
      "boards/#{ id }/plugins"
    )

  loadCustomFields: (id) ->
    @_loadApiData ModelName.BOARD, id, Payloads.customFields

  loadQuickBoardsData: ->
    @_loadApiData ModelName.MEMBER, 'me', Payloads.memberQuickBoards

  loadQuickBoardsSearch: (search) ->
    @_loadApiData 'search', null, {
      query: Payloads.quickBoardsSearch.query(search)
    }, 'search'

  loadAction: (id) ->
    @_loadApiData ModelName.ACTION, id, Payloads.action

  loadReactions: (idAction) ->
    @_loadApiData ModelName.REACTION, idAction, {}, "actions/#{ idAction }/reactions"

  loadBCFeatures: (id) ->
    @_loadApiData ModelName.ORGANIZATION, id, Payloads.bcFeatures

  triggerWaits: (type) ->
    _waitComplete[type] = true

    for callback in _waitCallbacks[type] ? []
      callback()
    delete _waitCallbacks[type]

  waitFor: (type, callback) ->
    if _waitComplete[type]
      callback()
    else
      (_waitCallbacks[type] ?= []).push(callback)

  await: (type) ->
    new Promise (resolve) =>
      @waitFor type, resolve
